import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { productShortName } from '../data/offer';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-211" data-mp="21ydbohrq2ixm">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-lg border border-stone-200 border-l-4 border-l-amber-500 bg-white p-4 pr-10 text-stone-900 shadow-xl shadow-stone-900/20" aria-live="polite" data-id="element-212" data-mp="1wxxvlig22xby">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-stone-500 transition-colors duration-150 ease-out hover:text-emerald-950 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-300" aria-label="Cerrar aviso" data-id="element-213" data-mp="1sdtg1dq4zasg">
            <XIcon className="h-4 w-4" data-id="element-214" data-mp="19p4zf3yorrmh" />
          </button>
          <div className="flex gap-3" data-id="element-215" data-mp="19nlidb57hcjn">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-emerald-700" aria-hidden="true" data-id="element-216" data-mp="1egeni04l6mw9" />
            <div data-id="element-217" data-mp="zsa3mstss5bw">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-stone-500" data-id="element-218" data-mp="zstmqcv6ozri">Acceso confirmado</p>
              <p className="mt-1 text-sm leading-snug" data-id="element-219" data-mp="14o8y8y5pyjkr">
                Al completar tu compra recibes el
                <br data-id="element-220" data-mp="qsna0t7b83te" />
                <span className="font-bold text-emerald-950" data-id="element-221" data-mp="vpdsfn6l7bhz">{productShortName}</span>
              </p>
              <p className="mt-2 text-xs text-stone-700" data-id="element-222" data-mp="2xejd3jre0v3z">Acceso digital inmediato por correo electrónico</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}